import React from "react";
import { IconBase, type IconProps } from "./IconBase";
import serversSVG from "images/icons/audit_logs_servers.svg";

export function ServersIcon(props: IconProps) {
  return <IconBase {...props} href={serversSVG} />;
}
